import * as React from "react";
import { SVGProps } from "react";

const AkashNetwork = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    viewBox="0 0 30 26"
    {...props}
  >
    <style>{".st0{fill-rule:evenodd;clip-rule:evenodd;fill:#ed3524}"}</style>
    <g id="Page-1">
      <g id="R15_Mobile_Home" transform="translate(-172 -62)">
        <g id="Top">
          <g id="Group-20" transform="translate(17 61)">
            <g id="akash-logo" transform="translate(155 1)">
              <path
                id="Fill-11"
                d="m9.9 0 15.4 26.6 5.1-8.9L20.1 0z"
                className="st0"
              />
              <path
                id="Fill-12"
                fill="#ae1e23"
                fillRule="evenodd"
                d="m9.9 18.2 5.3 8.4h10.6l-5.3-8.4z"
                clipRule="evenodd"
              />
              <path
                id="Fill-13"
                d="M5.3 8.4 0 17.5l5.3 9.1L16 8.4z"
                className="st0"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default AkashNetwork;
